export enum TopNavHeight {
  DESKTOP_DEFAULT = 'top-nav',
  DESKTOP_SHRUNK = 'top-nav--is-shrunk',
  MOBILE = 'top-nav--is-mobile',
}

export const setTopNavHeight = (className: TopNavHeight) => {
  const bodyEl = document.body;
  const { DESKTOP_DEFAULT, DESKTOP_SHRUNK, MOBILE } = TopNavHeight;
  const remove = (cName: TopNavHeight) => bodyEl.classList.remove(cName);
  const add = (cName: TopNavHeight) => bodyEl.classList.add(cName);

  switch (className) {
    case DESKTOP_DEFAULT:
      remove(DESKTOP_SHRUNK);
      remove(MOBILE);
      break;
    case DESKTOP_SHRUNK:
      remove(MOBILE);
      add(DESKTOP_SHRUNK);
      break;
    case MOBILE:
      remove(DESKTOP_SHRUNK);
      add(MOBILE);
      break;
    default:
      break;
  }
};
